import React from "react";

export default function batchWorkspace({ color = "white" }) {
  const str1 = "l-1.481-.897-7.044 4.218c-.225.134-.45.179-.673.179-.225 0-.494-.045-.674-.18";
  const str2 = "c.045.044.135.044.225.044s.179 0 .223-.044";
  const str3 = `.224.404l8.974 5.384${str2}l8.974-5.384`;
  const str4 = "a.47.47 0 0 0 .224-.404.47.47 0 0 0-.224-.404";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20">
      <g fill={color} fillRule="evenodd">
        <path
          d={`M18.7 13.185${str1}l-7.044-4.172-1.48.898c-.135.044-.225.178-.225.358s.09.315${str3}${str4}`}
        />
        <path
          d={`M18.7 9.596${str1}L1.784 8.745l-1.48.897C.168 9.685.078 9.82.078 10s.09.314${str3}${str4}`}
        />
        <path
          d={`M18.7 6.006L9.724.623a.41.41 0 0 0-.448 0L.303 6.006a.472.472 0 0 0-.224.404c0 .18.09.315.224.404L9.277 12.2${str2}L18.7 6.814${str4}`}
        />
      </g>
    </svg>
  );
}
